import React from 'react';
import PropTypes from 'prop-types';
import {withStyles, makeStyles} from '@material-ui/core/styles';
import {Hidden, Button, Tooltip, ClickAwayListener} from '@material-ui/core';

type Props = {
  children?: Node,
  title?: Node,
  isToolTip?: boolean,
};

const useStyles = makeStyles(theme => ({
  button: {
    paddingLeft: 0,
    '&:hover': {
      background: 'transparent',
    },
    '&:focus': {
      background: 'transparent',
    },
  },
}));

const LightTooltip = withStyles(theme => ({
  tooltip: {
    background: '#EEE5FF',
    borderRadius: '8px',
    color: '#7B39FF',
    maxWidth: 196,
    textAlign: 'center',
    padding: 8,
    fontStyle: 'normal',
    fontWeight: 300,
    fontSize: '10px',
    lineHeight: '10px',
    marginTop: '12px',
    marginBottom: '12px',
  },
}))(Tooltip);

export default function CustomTooltip(props: Props) {
  const {children, title, isToolTip} = props;
  const classes = useStyles();

  const [open, setOpen] = React.useState(false);

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleTooltipOpen = () => {
    setOpen(true);
  };

  return isToolTip ? (
    <>
      <Hidden smUp>
        <ClickAwayListener onClickAway={handleTooltipClose}>
          <LightTooltip
            PopperProps={{
              disablePortal: true,
            }}
            onClose={handleTooltipClose}
            open={open}
            disableFocusListener
            disableHoverListener
            disableTouchListener
            placement="right"
            title={title}
          >
            <Button onClick={handleTooltipOpen}>{children}</Button>
          </LightTooltip>
        </ClickAwayListener>
      </Hidden>
      <Hidden xsDown>
        <LightTooltip disableFocusListener placement="right" title={title}>
          <Button className={classes.button}>{children}</Button>
        </LightTooltip>
      </Hidden>
    </>
  ) : (
    <div>{children}</div>
  );
}

CustomTooltip.propTypes = {
  children: PropTypes.node,
  title: PropTypes.node,
};
